import { render, staticRenderFns } from "./SuggestedSession.vue?vue&type=template&id=6d2ca69a&scoped=true&lang=pug&"
import script from "./SuggestedSession.vue?vue&type=script&lang=js&"
export * from "./SuggestedSession.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedSession.vue?vue&type=style&index=0&id=6d2ca69a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ca69a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
